module.exports = __webpack_public_path__ + "static/img/10.0dcdc1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka3/10.jpg
// module id = I62n
// module chunks = 16